import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import type { FlagId } from './flags';
import { useFlag } from './useCan';

/**
 * Renders a route only while its flag is on, and answers 404 otherwise - the
 * same failure a route gives a user without the capability, so a switched-off
 * feature and one you were never given look alike from outside.
 *
 * This checks the flag and nothing else. Routes behind a capability already
 * have their own guard, and a switched-off flag has already removed that
 * capability; this is for the routes with no capability guard, so that a
 * flag still closes them to someone typing the URL. There is no pending state
 * to wait for: the flags are settled before the first render.
 */
export function RequireFlag({ flag, children }: { flag: FlagId; children: ReactNode }) {
  return useFlag(flag) ? <>{children}</> : <Navigate to="/404" replace />;
}
